import { ReactElement } from 'react'

import { DismissableAlert } from 'components/DismissableAlert'
import { hashCode } from 'helpers/hashCode'
import { GlobalNotification } from 'types'

interface Props {
    globalNotification?: GlobalNotification | null
}

const GlobalNotificationBanner = ({
    globalNotification = null,
}: Props): ReactElement | null => {
    if (!globalNotification || !globalNotification.enabled) {
        return null
    }

    const messageHashCode = hashCode(globalNotification.message.slice(0, 500))

    return (
        <DismissableAlert
            storageKey={`global-notification-${messageHashCode}`}
            numberOfDaysToHideAfterDismiss={1}
            type={globalNotification.type}
            message={
                <span
                    dangerouslySetInnerHTML={{
                        __html: globalNotification.message,
                    }}
                />
            }
            banner
        />
    )
}

export default GlobalNotificationBanner
